import { Close } from "@mui/icons-material";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Skeleton,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Snackbar,
  Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import MuiAlert from "@mui/material/Alert";
import moment from "moment/moment";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const StyledHeaderTitle = styled(DialogTitle)(({ theme }) => ({
  background: theme.palette.primary.main,
  color: "#fff",
  position: "relative",
  "& button": {
    position: "absolute",
    right: "15px",
    top: "15px",
    color: "#fff",
  },
}));

const carrierColumns = [
  { id: "netsuiteID", name: "Netsuite ID" },
  { id: "name", name: "Carrier Name" },
  { id: "customer_name", name: "Customer" },
  { id: "custrecord_cam_isdefault", name: "Default" },
  { id: "branch_name", name: "Location" },
  { id: "custrecord_cam_location_alias", name: "Location Alias" },
  { id: "custrecord_cam_customer_alias", name: "Customer Alias" },
  { id: "lastmodified", name: "Last Modified" },
];

const ViewNetsuiteCarrierDetails = (props) => {
  const [dialogDetails, setDialogDetails] = useState({ open: true });
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [messageState, setMessageState] = useState("");

  useEffect(() => {
    props.sendDetails(dialogDetails);
  }, [props, dialogDetails]);

  const handleClose = () => {
    setDialogDetails({ ...dialogDetails, open: false });
  };

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") return;
    setOpen(false);
  };

  return (
    <div>
      <Dialog
        open={dialogDetails.open}
        onClose={handleClose}
        maxWidth="lg"
        fullWidth
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <StyledHeaderTitle id="alert-dialog-title">
          <div>
            View Carrier Details{" "}
            {"(" + (props.carrierName || "-") + ")"}
          </div>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </StyledHeaderTitle>
        
        {props.singleLoading ? (
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Box p={3} sx={{ width: "100%" }}>
                  {Array.from({ length: 8 }).map((_, index) => (
                    <Skeleton key={index} height={40} />
                  ))}
                </Box>
              </Grid>
            </Grid>
          </DialogContent>
        ) : (
          <DialogContent sx={{ padding: "24px" }}>
            {props.viewDetails && props.viewDetails.length > 0 ? (
              <TableContainer component={Paper}>
                <Table aria-label="carrier details table">
                  <TableHead>
                    <TableRow>
                      {carrierColumns.map((column) => (
                        <TableCell key={column.id} style={{ fontWeight: 'bold' }}>
                          {column.name}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {props.viewDetails.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell component="th" scope="row">
                          {row.netsuiteID}
                        </TableCell>
                        <TableCell>{row.name}</TableCell>
                        <TableCell>{row.customer_name}</TableCell>
                        <TableCell>
                          {row.custrecord_cam_isdefault ? "Yes" : "No"}
                        </TableCell>
                        <TableCell>{row.branch_name || '-'}</TableCell>
                        <TableCell>{row.custrecord_cam_location_alias}</TableCell>
                        <TableCell>{row.custrecord_cam_customer_alias}</TableCell>
                        <TableCell>
                          {moment(row.lastmodified).format("ddd, MMM Do YYYY, h:mm:ss a")}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Typography variant="body1" align="center" sx={{ py: 4 }}>
                No carrier details found
              </Typography>
            )}
          </DialogContent>
        )}
        
        <DialogActions>
          <Button onClick={handleClose} variant="outlined" color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
   
      <Snackbar
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={open}
        onClose={handleCloseSnack}
      >
        <Alert
          onClose={handleCloseSnack}
          severity={messageState}
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default ViewNetsuiteCarrierDetails;